/*
 *   File : text-input.js
 *   Author : https://evoqins.com
 *   Description : Text input component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { memo } from "react";

//custom style
// import styles from "../../Style/Components/input.module.scss";

const Input = (props) => {
  // const [isInputFocused, setIsInputFocused] = useState(false);

  // // handle focus
  // const _handleFocus = () => {
  //   setIsInputFocused(true);
  // };

  // const _handleBlur = () => {
  //   setIsInputFocused(false);
  // };

  //input handle change
  const _handleChange = (e) => {
    const { value } = e.target;

    if (props.type.toLowerCase() === "text") {
      props.handleChange(capitalizeFirstLetter(value));
    } else if (props.type.toLowerCase() === "number") {
      const numberPattern = props.allowDecimal
        ? /^\d*\.?\d{0,1}$/
        : /^\d*$/;
      if (numberPattern.test(value)) {
        props.handleChange(value);
      }
    } else {
      props.handleChange(value);
    }
  };

  // handle enter key press
  const _keyPress = (e) => {
    if (e.keyCode === 13) {
      props.onKeyPress();
    }
  };

  const _handleKeyDown = (e) => {
    // Prevent default behavior of up and down arrow keys
    if (e.keyCode === 38 || e.keyCode === 40) {
      e.preventDefault();
    }
    if (props.type === "number" && !props.allowDecimal) {
      if (e.key === "0" && props.value === "") {
        e.preventDefault();
      }
    }
    if (e.key === "." && props.not_decimal) {
      e.preventDefault();
    }
  };

  function capitalizeFirstLetter(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return (
    <div>
      {props.label && (
        <label
          className={
            props.labelStyle
              ? props.labelStyle
              : "e-text-black e-primary-font-poppins  e-font-weight-500  e-font-14 pb-1"
          }
        >
          {props.label}
          {props.require && <span className="text-danger">*</span>}
        </label>
      )}

      <div className={`${!props.search && !props.readOnly && `h-64px`}`}>
        <input
          id={props.id}
          ref={props.ref}
          value={props.value}
          defaultValue={props.defaultValue}
          maxLength={props.maxLength}
          tabIndex={props.tabIndex}
          type={props.type}
          min={props.min}
          step={props.step}
          required={props.required}
          readOnly={props.readOnly}
          autoFocus={props.autoFocus}
          placeholder={props.placeholder}
          className={`${props.error && "e-border-1px-ruby"} p-3 ${props.className} e-input-element  bg-white e-font-weight-400 e-primary-font-poppins`}
          onWheel={() => document.activeElement.blur()}
          // onFocus={_handleFocus}
          // onBlur={_handleBlur}
          onChange={_handleChange}
          // onKeyDown={(e) => keyPress(e)}
          onKeyDown={(e) => {
            _keyPress(e);
            _handleKeyDown(e);
          }}
          onClick={props.onClick}
        />
        {props.error && (
          <p className="mb-0 e-font-12 text-danger e-primary-font-poppins  pt-1">
            {props.error}
          </p>
        )}
      </div>
    </div>
  );
};

Input.defaultProps = {
  onKeyPress: () => {},
  className: null,
  error: "",
  value: "",
};

export default memo(Input);
